import { ComponentPropsWithRef, RefObject } from "react"

import { classNames } from "../../../../lib/classNames"

interface CardProps extends ComponentPropsWithRef<"div"> {
  ref?: RefObject<HTMLDivElement | null>
}

export const Card = (props: CardProps) => {
  const { ref, className, children, ...otherProps } = props

  return (
    <div
      ref={ref}
      className={classNames(
        "border-v2-border-default rounded-surface bg-v2-background-elevation-raised flex flex-1 flex-col border p-4",
        className
      )}
      {...otherProps}
    >
      {children}
    </div>
  )
}

Card.displayName = "Card"
